module.exports = __webpack_public_path__ + "img/float-btn-fish.87caa4e4.svg";